import { defineMessages, IntlShape } from "react-intl";

import LocationPermission from "@mapmycustomers/shared/enum/LocationPermission";

import { getDisplayName } from "@app/util/ui/getDisplayName";

import PermissionStatus from "../enum/PermissionStatus";
import LocationStatus from "../types/LocationStatus";

const messages = defineMessages<LocationStatus>({
  [LocationPermission.ALLOWED_ONCE]: {
    id: "reports.permissionsReport.locationStatus.allowedOnce",
    defaultMessage: "Allowed Once",
    description: "Location permission granted for a single session only",
  },
  [LocationPermission.ALWAYS]: {
    id: "reports.permissionsReport.locationStatus.always",
    defaultMessage: "Always",
    description: "Location permission granted at all times",
  },
  [LocationPermission.OFF]: {
    id: "reports.permissionsReport.locationStatus.off",
    defaultMessage: "Off",
    description: "Location permission denied",
  },
  [LocationPermission.WHILE_USING]: {
    id: "reports.permissionsReport.locationStatus.whileUsing",
    defaultMessage: "While Using",
    description: "Location permission granted only while the app is open",
  },
  [PermissionStatus.MIXED]: {
    id: "reports.permissionsReport.locationStatus.mixed",
    defaultMessage: "Mixed",
    description: "Location differs between a rep's devices",
  },
  [PermissionStatus.UNKNOWN]: {
    id: "reports.permissionsReport.locationStatus.unknown",
    defaultMessage: "Unknown",
    description: "Location permission has never been reported",
  },
});

const getLocationStatusDisplayName = (intl: IntlShape, status: LocationStatus) =>
  getDisplayName(intl, messages, status, "LocationStatus");

export default getLocationStatusDisplayName;
